import { render, staticRenderFns } from "./SettingLog.vue?vue&type=template&id=adbecf1c&"
import script from "./SettingLog.vue?vue&type=script&lang=ts&"
export * from "./SettingLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports